(ns common.security.password-complexity)

(def complexity-options [{:key               :password-complexity/capital-case
                          :label             "Capital case letter"
                          :plural-lower-case "capital case letters"}
                         {:key               :password-complexity/lower-case
                          :label             "Lower case letter"
                          :plural-lower-case "lower case letters"}
                         {:key               :password-complexity/number
                          :label             "Number"
                          :plural-lower-case "numbers"}
                         {:key               :password-complexity/special-character
                          :label             "Special character"
                          :plural-lower-case "special characters"}])
